/** Bliss Basic landing — six-step options wizard (tenant photos per step). */

export const BLISS_BASIC_OPTION_CATEGORY_IDS = [
  'bed_type',
  'layout',
  'storage',
  'safety',
  'access',
  'lighting',
] as const

export type BlissBasicOptionCategoryId = (typeof BLISS_BASIC_OPTION_CATEGORY_IDS)[number]

export type BlissBasicOptionCategoryDef = {
  id: BlissBasicOptionCategoryId
  step: number
  title: string
  subtitle: string
  examples: string
}

export const BLISS_BASIC_OPTION_CATEGORIES: BlissBasicOptionCategoryDef[] = [
  {
    id: 'bed_type',
    step: 1,
    title: 'Bed type',
    subtitle: 'Bed type selection',
    examples: 'Loft · Platform · Bunk · Tower',
  },
  {
    id: 'layout',
    step: 2,
    title: 'Layout',
    subtitle: 'Layout choices',
    examples: 'L-Shape · Perpendicular · Parallel · Combo',
  },
  {
    id: 'storage',
    step: 3,
    title: 'Storage',
    subtitle: 'Storage options',
    examples: 'Niches · Drawers',
  },
  {
    id: 'safety',
    step: 4,
    title: 'Safety',
    subtitle: 'Guardrail selections',
    examples: 'Guardrail styles & heights',
  },
  {
    id: 'access',
    step: 5,
    title: 'Access',
    subtitle: 'Access type',
    examples: 'Stairs · Ladder',
  },
  {
    id: 'lighting',
    step: 6,
    title: 'Lighting',
    subtitle: 'Built-in lighting',
    examples: 'Single · Double · Triple · Quad bunk lighting',
  },
]

export function isBlissBasicOptionCategoryId(value: string | null | undefined): value is BlissBasicOptionCategoryId {
  return BLISS_BASIC_OPTION_CATEGORY_IDS.includes(value as BlissBasicOptionCategoryId)
}

export function blissBasicOptionCategoryById(id: string | null | undefined): BlissBasicOptionCategoryDef | undefined {
  if (!id || !isBlissBasicOptionCategoryId(id)) return undefined
  return BLISS_BASIC_OPTION_CATEGORIES.find((c) => c.id === id)
}
